import React from 'react';
import {MasterLayout} from 'components/layouts';
import {
  HomeBanner,
  SupportInfoContainer,
  BackgroundPage,
  ListCategoryInFair,
  AdsContainer
} from './sub-view';
import {withRouter} from 'react-router';
import title from 'constants/TitlePages.js';
import {System} from 'api';
import {connect} from 'react-redux';

import {asyncConnect} from 'redux-connect';
import CONFIG from 'base/constants/config';

@asyncConnect([
  {
    key: 'nokey',
    promise: ({match: {
        params
      }, store: {
        dispatch
      }, helpers}) => {
      dispatch({
        type: 'SEO_INFO',
        data: {
          title: title.Home,
          description: 'Sàn giao dịch thương mại điện tử ViTrade là một thị trường trực tuyến, một địa điểm họp chợ online được thực hiện trên mạng internet giữa người bán và người mua, ở đó những người tham gia có thể tự mình tìm kiếm thông tin về thị trường và sản phẩm – dịch vụ, thiết lập mối quan hệ cũng như tiến hành đàm phán trong từng giao dịch.',
          image: `${CONFIG.UploadImageURL}/03708aed6ad48b41b843785cf1d0d3de.jpg`
        }
      });
    }
  }
])

class Home extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = title.Home;
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.props.SystemInfo !== prevProps.SystemInfo) {
      this.forceUpdate();
    }
  }

  render() {
    let {SystemInfo} = this.props
    let backgroundImage = SystemInfo && SystemInfo.themeInfo && SystemInfo.themeInfo.backgroundPattern ? SystemInfo.themeInfo.backgroundPattern : ''
    return (
      <MasterLayout backgroundImage={backgroundImage ? `url(${CONFIG.VITRADE_IMAGE_URL}/resize/220x220/fairs/download/${backgroundImage})` : null}>
        <HomeBanner/>
        <div className='content-main' id='contentMain'>
          <BackgroundPage/>
          <AdsContainer/>
          <ListCategoryInFair/>
          {/* hidden - 14/03/2019*/}
          {/* <SupportInfoContainer/> */}
        </div>
      </MasterLayout>
    );
  }
}

const bindStateToProps = (state) => {
  return {
    SystemInfo: state.System.data || {}
  };
};

export default connect(bindStateToProps)(withRouter(Home));



// WEBPACK FOOTER //
// ./components/home/Home.jsx